module.exports = __webpack_public_path__ + "img/fukuoka.82f6be19.jpg";